import { render, staticRenderFns } from "./TranscriptQueueAOR.vue?vue&type=template&id=0d9fc582&"
import script from "./TranscriptQueueAOR.vue?vue&type=script&lang=js&"
export * from "./TranscriptQueueAOR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports